// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailBlock_wrapper__gkt4I","label":"DetailBlock_label__ePjla","value":"DetailBlock_value__Xjqbh"};